
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 4.23c0-.285-.112-.559-.312-.76a1.062 1.062 0 00-.755-.316h-8L6.653 1.43A1.07 1.07 0 005.8 1H2.067c-.283 0-.555.113-.755.315-.2.202-.312.476-.312.762v11.846A1.067 1.067 0 002.067 15h13.866A1.067 1.067 0 0017 13.923V4.231z","stroke":"#666","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    